export default {
  apiKey: "AIzaSyCqWMe1dYwnloBKVyX4BESlLSW0SusNukU",
  authDomain: "invoice-generator-dev.firebaseapp.com",
  databaseURL: "https://invoice-generator-dev.firebaseio.com",
  projectId: "invoice-generator-dev",
  storageBucket: "invoice-generator-dev.appspot.com",
  messagingSenderId: "453740576736",
  appId: "1:453740576736:web:ef1c01b7a311b44c8bb585",
  measurementId: "G-8EBJW7JWQ6"
}